import React, { useCallback } from "react";
import { Form, Input, Row, Col, Checkbox, Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { zipValidator } from "../../../../utils/validator";

const { TextArea } = Input;

const PhysicalAddressSection = ({
  conditionalFields,
  handleSameAsMailing,
}) => {
  return (
    <div className="p-5">
      <p className="mb-2 font-medium text-[16px]">Current Address</p>
      
      <Row gutter={[16, 16]}>
        <Col span={12} sm={24} md={24} lg={12}>
          <Form.Item name="address1" label="Address Line 1">
            <Input placeholder="Enter Address" maxLength={100} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={12} sm={24} md={24} lg={12}>
          <Form.Item name="address2" label="Address Line 2">
            <Input placeholder="Enter Address" maxLength={100} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item name="city" label="City">
            <Input placeholder="Enter City" maxLength={30} />
          </Form.Item>
        </Col>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item name="state" label="State/ Province">
            <Input placeholder="Enter State/Province" maxLength={30} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="zip"
            label="Zip Code/ Postal Code"
            rules={[{ validator: zipValidator }]}
          >
            <Input placeholder="Enter Zip Code/ Postal Code" />
          </Form.Item>
        </Col>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item name="country" label="Country">
            <Input placeholder="Enter Country" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12} sm={24} md={24} lg={12}>
          <Form.Item name="current_address_notes" label="Note">
            <TextArea
              showCount
              maxLength={300}
              placeholder="Enter Address Notes"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={12} sm={24} md={24} lg={24}>
          <Checkbox defaultChecked={true} onChange={handleSameAsMailing}>
            Mailing Address same as current address
          </Checkbox>
          <Tooltip title="Please uncheck the box to enter mailing address">
            <InfoCircleFilled className="ml-1 text-[#1890ff]" />
          </Tooltip>
        </Col>
      </Row>

      {conditionalFields.isSame && (
        <>
          <p className="mb-2 font-medium text-[16px]">
            Mailing Address
          </p>
          <Row gutter={[16, 16]}>
            <Col span={12} sm={24} md={24} lg={12}>
              <Form.Item name="mailingAddress1" label="Address Line 1">
                <Input placeholder="Enter Address" maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12} sm={24} md={24} lg={12}>
              <Form.Item name="mailingAddress2" label="Address Line 2">
                <Input placeholder="Enter Address" maxLength={100} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={6} sm={24} md={12} lg={6}>
              <Form.Item name="mailingCity" label="City">
                <Input placeholder="Enter City" maxLength={100} />
              </Form.Item>
            </Col>
            <Col span={6} sm={24} md={12} lg={6}>
              <Form.Item name="mailingState" label="State/ Province">
                <Input
                  placeholder="Enter State/Province"
                  maxLength={30}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={6} sm={24} md={12} lg={6}>
              <Form.Item
                name="mailingZip"
                label="Zip"
                rules={[{ validator: zipValidator }]}
              >
                <Input placeholder="Enter Zip Code" />
              </Form.Item>
            </Col>
            <Col span={6} sm={24} md={12} lg={6}>
              <Form.Item name="mailingCountry" label="Country">
                <Input placeholder="Enter Country" maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default React.memo(PhysicalAddressSection);
